import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import SmsIcon from "../../assets/icons/originator.svg2";
import EmailIcon from "../../assets/icons/icon_email-01.svg2";
import VoiceIcon from "../../assets/icons/icon_voice_tel-01.svg2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MyIcon from "../Common/MyIcon";
import ReceipentsTab from "./RecipientsTab";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import { h } from "vue";
import HelpButton from "../HelpContent/HelpButton";
import ContactsList from "../Contacts/ContactsList";
import { toCamel } from "../Maps/helpers";
import { useListContactsAndGroupsInLocationQuery } from "../store/slices/mapsSlice";
import TokenEditor from "../Builder/Components/TokenEditor";
import DynamicHeaderInput from "../Builder/nodes/Logic/Inputs/DynamicHeaderInput";

export default function EventRecipients({ event, setEvent, isEventMinimal }) {
  const { data: contactsAndGroupsData } =
    useListContactsAndGroupsInLocationQuery(
      event?.ContactsAndAssetsCriteria || {},
      { skip: !event?.ContactsAndAssetsCriteria }
    );
  return (
    <Row className="py-3 mt-2 ps-4 pe-4 m-2">
      <Col className="col-5 border-end pe-4">
        <div className="mb-3">
          <span className="fs-4 fw-bold">How would you like to send this?</span>
          <div className="text-secondary">
            Choose the preferred communication channels for this event.
          </div>
        </div>
        <div className="row  g-3 mb-3 ">
          {[
            {
              value: "sms",
              label: "SMS",
              icon: SmsIcon,
              helpId: "event-channel-sms",
            },
            {
              value: "email",
              label: "EMAIL",
              icon: EmailIcon,
              helpId: "event-channel-email",
            },
            {
              value: "voice",
              label: "VOICE",
              icon: VoiceIcon,
              helpId: "event-channel-voice",
            },
          ].map((c) => (
            <div className="col-12 col-sm-4" key={c.value}>
              <button
                type="button"
                className={`btn w-100 h-100 bg-white p-2 py-4 rounded-3 position-relative border border-2 ${
                  event?.PreferredChannels?.includes(c.value)
                    ? "border-blue"
                    : ""
                }`}
                onClick={() => {
                  let newChannels = event?.PreferredChannels || [];
                  if (newChannels.includes(c.value)) {
                    newChannels = newChannels.filter((ch) => ch !== c.value);
                  } else {
                    newChannels.push(c.value);
                  }
                  setEvent({
                    ...event,
                    PreferredChannels: newChannels,
                  });
                }}
              >
                {event?.PreferredChannels?.includes(c.value) ? (
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="position-absolute top-0 end-0 text-white bg-colored p-1"
                    style={{ borderBottomLeftRadius: 8 }}
                  />
                ) : null}
                <div className="d-flex align-items-center ms-3">
                  <MyIcon width={25} Icon={c.icon} className=" me-3" />
                  <div>
                    <div className="fw-bold overflow-hidden">{c.label}</div>
                    <div className="position-absolute top-0 start-0">
                      {c.helpId && <HelpButton helpKey={c.helpId} />}
                    </div>
                  </div>
                </div>
              </button>
            </div>
          ))}
        </div>

        {isEventMinimal && event?.PreferredChannels?.includes("sms") && (
          <div className="mb-3">
            <div className="fw-bold fs-4">Dynamic header</div>
            <DynamicHeaderInput
              placeholder="Message config DynamicHeader"
              value={event?.DynamicHeader ?? ""}
              onChange={(v) => setEvent({ ...event, DynamicHeader: v })}
            />
          </div>
        )}

        <div className="">
          {/* Selected contacts */}
          <div className="">
            <div className="fw-bold fs-4">Contacts</div>
            {event?.Areas?.[0]?.geometry?.coordinates ||
            event?.Assets?.length ||
            event?.Contacts?.length ||
            event?.ContactsAndAssetsCriteria?.Coordinates ||
            event?.ContactsAndAssetsCriteria?.IncludeContacts?.length ? (
              <div className="">
                <ContactsList
                  contacts={toCamel(contactsAndGroupsData?.contacts) || []}
                  allContactsButton={undefined}
                  refreshList={undefined}
                  notDraggable={undefined}
                  fullView={undefined}
                  isModal={undefined}
                  showContactFields={undefined}
                  onSelectContacts={undefined}
                  highlighChannelsIfNotAvailable={event?.PreferredChannels?.map(
                    (ch) =>
                      `is${
                        ch.charAt(0).toUpperCase() + ch.slice(1).toLowerCase()
                      }`
                  )}
                />
              </div>
            ) : (
              <div className="alert alert-secondary">No criteria selected.</div>
            )}
          </div>
        </div>
      </Col>

      <Col className="col-7 ps-4">
        <div className="my-2">
          <span className="fs-4 fw-bold">Message to send</span>
          <div className="mt-2 large-editor">
            <TokenEditor
              tokenTags={["contact_field"]}
              showButtons
              showShortlinksButton={false}
              rawEditorState={
                JSON.parse(event?.EditorMessage || "{}").EditorState
              }
              onChange={({ rawEditorState, tokens }) => {
                setEvent((prev) => ({
                  ...prev,
                  EditorMessage: JSON.stringify({
                    EditorState: rawEditorState,
                    Tokens: tokens,
                  }),
                }));
              }}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
}
